module.exports = __webpack_public_path__ + "img/software-thumb-2.35103ffd.png";